var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentMesage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.47,
    cy: 363.75,
    rx: 209.77,
    ry: 121.11,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.1,
    cy: 377.74,
    rx: 49.24,
    ry: 28.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.58,
    cy: 398.15,
    rx: 59.62,
    ry: 34.42,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234,366.86c0-2.5-1.64-5-4.94-6.89-6.59-3.81-17.28-3.81-23.87,0-3.3,1.9-4.95,4.4-4.95,6.89v7.71c0,2.5,1.65,5,4.95,6.9,6.59,3.8,17.28,3.8,23.87,0,3.3-1.91,4.94-4.4,4.94-6.9h0v-7.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,367.68c6.59,3.81,6.59,10,0,13.79s-17.28,3.8-23.87,0-6.6-10,0-13.79S222.51,363.88,229.1,367.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.28,
    y: 366.86,
    width: 33.76,
    height: 7.71,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,360c6.59,3.8,6.59,10,0,13.78s-17.28,3.81-23.87,0-6.6-10,0-13.78S222.51,356.16,229.1,360Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,361.72c3.11,1.79,3.11,4.7,0,6.49a12.43,12.43,0,0,1-11.24,0c-3.1-1.79-3.1-4.7,0-6.49A12.43,12.43,0,0,1,222.78,361.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.21,
    y: 219.41,
    width: 15.9,
    height: 145.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.09,152.19h0l0-.11v0c-.15-.83-.33-1.67-.54-2.51a2.68,2.68,0,0,1,.07.27c-.13-.57-.28-1.14-.44-1.71.06.21.11.42.16.63-.16-.63-.34-1.25-.53-1.88.09.27.18.55.25.82-.1-.36-.21-.72-.32-1.08l-.18-.57,0-.08v.06a61.06,61.06,0,0,0-5.28-11.71c-.07-.13-.14-.26-.22-.39h0c-5.45-9.27-13.35-17.74-22.17-23l-.43-.26a40,40,0,0,0-8-3.54,24.74,24.74,0,0,0-7.16-1.15l-.84,0-.51,0c-.42,0-.83.08-1.23.14l-.37,0-.68.13c-.29.06-.58.13-.86.21l-.78.23s0,0-.05,0l-.78.28c-.26.11-.52.22-.76.34h0l-1.72,1,0,0-86.61,50,0,0-.07,0h0c-4.69,2.63-7.53,8-7.53,15.63v47.11l-32.59,18a20.81,20.81,0,0,0-.37,36.24h0a59.73,59.73,0,0,0,59.69,0L195,256.29h0l87.73-50.69V158.48A35.37,35.37,0,0,0,282.09,152.19Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 140.61 165.15 196.33 133.29 201.35 181.95 140.61 217.78",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 140.61 165.15 196.33 133.29 201.35 181.95 140.61 217.78",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 201.35 181.95 201.35 239.22 188.79 245.6 140.61 217.78",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 201.35 181.95 201.35 239.22 188.79 245.6 140.61 217.78",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,152.19l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24c-2.78-4.7-10-26.63-13.85-30.6a58,58,0,0,0-12.58-10c-5.5-3.18-10.65-4.69-15.1-4.69a15.37,15.37,0,0,0-7.52,1.79l86.62-50,0,0,1.72-1h0c.24-.12.5-.23.76-.34l.78-.28s0,0,.05,0l.78-.23c.28-.08.57-.15.86-.21l.68-.13.37,0c.4-.06.81-.11,1.23-.14l.51,0,.84,0a24.74,24.74,0,0,1,7.16,1.15,40,40,0,0,1,8,3.54l.43.26C267.35,119.57,279.37,136.88,282.1,152.19Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,158.56l-.07,0h0Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.1,152.19l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24c-2.78-4.7-10-26.63-13.85-30.6a58,58,0,0,0-12.58-10c-5.5-3.18-10.65-4.69-15.1-4.69a15.37,15.37,0,0,0-7.52,1.79l86.62-50,0,0,1.72-1h0c.24-.12.5-.23.76-.34l.78-.28s0,0,.05,0l.78-.23c.28-.08.57-.15.86-.21l.68-.13.37,0c.4-.06.81-.11,1.23-.14l.51,0,.84,0a24.74,24.74,0,0,1,7.16,1.15,40,40,0,0,1,8,3.54l.43.26C267.35,119.57,279.37,136.88,282.1,152.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142,158.56l-.07,0h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M275,134h0c.08.12.16.25.23.38C275.19,134.22,275.12,134.09,275,134Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65,143.5a48.74,48.74,0,0,1,2.45,8.69l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24h0L195,256.29l87.73-50.69V158.48A42.72,42.72,0,0,0,279.65,143.5Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.35,140.36c-.37-.82-.76-1.65-1.17-2.47C277.59,138.71,278,139.54,278.35,140.36Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66,135c.42.76.84,1.52,1.23,2.29C276.5,136.56,276.09,135.8,275.66,135Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62,143.41c-.35-.9-.72-1.79-1.11-2.68C278.9,141.62,279.27,142.51,279.62,143.41Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275,134h0c.08.12.16.25.23.38C275.19,134.22,275.12,134.09,275,134Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.65,143.5a48.74,48.74,0,0,1,2.45,8.69l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24h0L195,256.29l87.73-50.69V158.48A42.72,42.72,0,0,0,279.65,143.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.35,140.36c-.37-.82-.76-1.65-1.17-2.47C277.59,138.71,278,139.54,278.35,140.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.66,135c.42.76.84,1.52,1.23,2.29C276.5,136.56,276.09,135.8,275.66,135Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.62,143.41c-.35-.9-.72-1.79-1.11-2.68C278.9,141.62,279.27,142.51,279.62,143.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,162.93c3.49,0,7.65,1.33,12,3.86,14.73,8.5,27.18,27.91,27.18,42.39V245.6l-48.18-27.82V174.23c0-9.34,4.88-11.3,9-11.3m0-6.18c-9.06,0-15.15,6.27-15.15,17.48v47.11l60.52,35V209.18c0-16.72-13.55-38.09-30.26-47.74h0c-5.5-3.17-10.67-4.69-15.11-4.69Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,221.34l-32.59,18a20.81,20.81,0,0,0-.37,36.24h0a59.73,59.73,0,0,0,59.69,0L195,256.29Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,221.34l-32.59,18a20.81,20.81,0,0,0-.37,36.24h0a59.73,59.73,0,0,0,59.69,0L195,256.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 241.94 208.35 245.86 208.35 180.21 215.15 176.28 215.15 241.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.99 181.99 208.35 193.32 208.35 180.21 227.99 168.87 227.99 181.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,239.63a14.1,14.1,0,0,1-6.38,11.05c-3.53,2-6.39.39-6.39-3.68A14.09,14.09,0,0,1,211.7,236C215.22,233.91,218.08,235.56,218.08,239.63Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,239.63a14.1,14.1,0,0,1-6.38,11.05c-3.53,2-6.39.39-6.39-3.68A14.09,14.09,0,0,1,211.7,236C215.22,233.91,218.08,235.56,218.08,239.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2,240.86a14.09,14.09,0,0,1-6.38,11c-3.52,2-6.38.38-6.38-3.69a14.13,14.13,0,0,1,6.38-11.05C217.35,235.14,220.2,236.79,220.2,240.86Z",
    style: {
      fill: "#227EA1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.72,349,374,355.54s-5.7-18.19-2.54-36.48c1.19-6.9,3.71-10.33,4.59-12.18s7.7-13.25,1.7-18.51-20.05,5.2-19.42,33.38A109.63,109.63,0,0,0,362.72,349Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72,349,374,355.54s-5.7-18.19-2.54-36.48c1.19-6.9,3.71-10.33,4.59-12.18s7.7-13.25,1.7-18.51-20.05,5.2-19.42,33.38A109.63,109.63,0,0,0,362.72,349Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,352.54a.52.52,0,0,1-.47-.33c0-.12-4.31-12-4.09-31s10.28-29.32,10.38-29.42a.5.5,0,1,1,.71.71c-.1.1-9.86,10-10.08,28.72s4,30.51,4,30.63a.5.5,0,0,1-.3.64A.39.39,0,0,1,368,352.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.47,354.11l18.65,11s8.54-1.26,7.9-9.3-4.12-9.94.2-13.47,5.44-3.76,5.23-7.23-2.53-5-3.63-6.34-4.15-4.25-2-8.43,5.06-8.21.74-10.12c-2.59-1.14-6.93.29-9.8,3.34s-5.26,5.26-8,6-8.41.76-8.22,5.46,1.41,6.32.27,8.4C370.68,337.29,361.51,339.41,371.47,354.11Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.07,359.08a.5.5,0,0,1-.5-.47c0-.28-2.06-28.08,17.26-46.34a.51.51,0,1,1,.7.73c-19,17.92-17,45.26-17,45.53a.51.51,0,0,1-.46.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.41,335.24a.5.5,0,0,1-.5-.46,15.88,15.88,0,0,0-5.67-11.1.5.5,0,1,1,.59-.81,16.58,16.58,0,0,1,6.09,11.83.5.5,0,0,1-.47.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,340a.48.48,0,0,1-.34-.13.5.5,0,0,1,0-.71c.2-.23,5.06-5.48,16.3-3.94a.52.52,0,0,1,.44.57.51.51,0,0,1-.57.43c-10.72-1.47-15.37,3.56-15.42,3.61A.51.51,0,0,1,381,340Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.35,190.53c-.89,0-1.79,0-2.67-.11a.91.91,0,0,1-.84-1,.93.93,0,0,1,1-.84,26.65,26.65,0,0,0,3.57.09.94.94,0,0,1,.95.89.92.92,0,0,1-.88.95C158.09,190.53,157.72,190.53,157.35,190.53Zm4.74-.38a.92.92,0,0,1-.15-1.83,26.53,26.53,0,0,0,3.47-.81.92.92,0,0,1,.53,1.76,28.07,28.07,0,0,1-3.7.87Zm-11-.26h-.18a34.57,34.57,0,0,1-3.66-1,.94.94,0,0,1-.59-1.17.93.93,0,0,1,1.17-.58,30.71,30.71,0,0,0,3.45.92.91.91,0,0,1,.71,1.09A.92.92,0,0,1,151.11,189.89Zm18-1.91a.92.92,0,0,1-.4-1.75l.64-.31a.92.92,0,1,1,.83,1.64l-.68.34A.91.91,0,0,1,169.11,188Zm-25-.39a.92.92,0,0,1-.39-.09,34.41,34.41,0,0,1-3.33-1.78.92.92,0,1,1,1-1.57,33,33,0,0,0,3.16,1.68.93.93,0,0,1-.39,1.76Zm-6.3-3.8a1,1,0,0,1-.55-.18c-1-.74-2-1.55-2.9-2.41a.92.92,0,1,1,1.24-1.36c.9.82,1.83,1.59,2.77,2.3a.92.92,0,0,1-.56,1.65Zm-5.43-4.95a.91.91,0,0,1-.68-.3c-.83-.91-1.65-1.88-2.41-2.88a.92.92,0,0,1,1.46-1.12c.73,1,1.51,1.88,2.31,2.76a.92.92,0,0,1-.06,1.3A.93.93,0,0,1,132.41,178.84ZM127.93,173a.9.9,0,0,1-.77-.43c-.4-.62-.79-1.26-1.16-1.9-.25-.44-.5-.89-.74-1.34a.92.92,0,0,1,1.62-.86c.23.43.47.86.71,1.28.36.62.73,1.23,1.12,1.83a.93.93,0,0,1-.78,1.42Zm-3.44-6.5a.92.92,0,0,1-.85-.56c-.49-1.16-.93-2.35-1.31-3.53a.92.92,0,0,1,.59-1.16.93.93,0,0,1,1.16.6c.36,1.13.78,2.26,1.25,3.37a.91.91,0,0,1-.84,1.28Zm-2.24-7a.93.93,0,0,1-.9-.73,34.84,34.84,0,0,1-.6-3.73.92.92,0,0,1,.82-1,.86.86,0,0,1,.39,0,.89.89,0,0,1,.67-.46,22,22,0,0,0,3.44-.76.92.92,0,0,1,.55,1.76,24.68,24.68,0,0,1-3.74.83.88.88,0,0,1-.23,0c.12,1,.29,2,.5,2.94a.91.91,0,0,1-.71,1.09A.63.63,0,0,1,122.25,159.51Zm-3.17-3.82h0a28.75,28.75,0,0,1-3.79-.31.92.92,0,0,1,.27-1.82,25.21,25.21,0,0,0,3.54.29.92.92,0,0,1,0,1.84Zm-7.26-1.08a.73.73,0,0,1-.25,0A29.33,29.33,0,0,1,108,153.3a.92.92,0,0,1,.73-1.69,26.82,26.82,0,0,0,3.36,1.19.93.93,0,0,1,.63,1.14A.94.94,0,0,1,111.82,154.61Zm17.93-1.33a.92.92,0,0,1-.42-1.73,15.2,15.2,0,0,0,2.88-1.92.93.93,0,0,1,1.3.09.92.92,0,0,1-.1,1.3,16.1,16.1,0,0,1-3.23,2.16A.94.94,0,0,1,129.75,153.28Zm-8.25-1.08h0a.93.93,0,0,1-.91-.94,31.26,31.26,0,0,1,.29-3.78.92.92,0,1,1,1.82.26,29.49,29.49,0,0,0-.27,3.55A.93.93,0,0,1,121.5,152.2Zm-16.44-.47a1,1,0,0,1-.46-.12,32.07,32.07,0,0,1-3.16-2.1.9.9,0,0,1-.18-1.28.92.92,0,0,1,1.29-.19,28.3,28.3,0,0,0,3,2,.92.92,0,0,1-.46,1.72Zm30.12-3.28a.93.93,0,0,1-.46-.12.92.92,0,0,1-.33-1.26,8.72,8.72,0,0,0,.66-1.43,6,6,0,0,0,.34-1.64.91.91,0,0,1,1-.85.92.92,0,0,1,.85,1,8.24,8.24,0,0,1-.44,2.12A10.59,10.59,0,0,1,136,148,.93.93,0,0,1,135.18,148.45Zm-36-1.14a.93.93,0,0,1-.64-.26l-.61-.62c-.67-.69-1.32-1.42-1.94-2.18a.92.92,0,1,1,1.43-1.16c.58.72,1.2,1.41,1.83,2.06l.57.58a.91.91,0,0,1,0,1.3A.94.94,0,0,1,99.2,147.31Zm23.36-2.38a.84.84,0,0,1-.27,0,.92.92,0,0,1-.61-1.15,14.82,14.82,0,0,1,1.59-3.57.92.92,0,1,1,1.56,1,12.91,12.91,0,0,0-1.39,3.13A.91.91,0,0,1,122.56,144.93Zm-28-3.32a.91.91,0,0,1-.77-.42,37,37,0,0,1-1.89-3.26.92.92,0,0,1,1.64-.84,34.76,34.76,0,0,0,1.79,3.1.92.92,0,0,1-.77,1.42Zm41.17-.23a.92.92,0,0,1-.85-.57,5.33,5.33,0,0,0-1.91-2.43.92.92,0,0,1,1-1.53,7.16,7.16,0,0,1,2.58,3.26.91.91,0,0,1-.49,1.2A.92.92,0,0,1,135.73,141.38Zm-9.17-2.46a.93.93,0,0,1-.76-.4.92.92,0,0,1,.24-1.28,8.15,8.15,0,0,1,3.86-1.41.92.92,0,1,1,.16,1.83,6.26,6.26,0,0,0-3,1.11A1,1,0,0,1,126.56,138.92Zm-35.37-3.84a.92.92,0,0,1-.85-.58c-.46-1.15-.88-2.34-1.24-3.55a.92.92,0,1,1,1.76-.53c.35,1.15.75,2.3,1.19,3.4a.93.93,0,0,1-.52,1.19A.8.8,0,0,1,91.19,135.08Zm-2.13-7a.92.92,0,0,1-.9-.73c-.26-1.21-.47-2.45-.64-3.7a.92.92,0,0,1,1.82-.24c.16,1.2.37,2.39.62,3.56a.92.92,0,0,1-.71,1.09Zm-1-7.29a.93.93,0,0,1-.92-.87c0-1-.08-2-.08-3v-.77a.94.94,0,0,1,.94-.9.9.9,0,0,1,.9.93v.74c0,1,0,1.92.08,2.87a.93.93,0,0,1-.86,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.26 87.3 91.76 111.2 31.7 98.31 97.26 87.3",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.26 87.3 91.76 111.2 31.7 98.31 97.26 87.3",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,98.31l74.78-2,17.57,27.08Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.7 98.31 97.26 87.3 81.81 69.38 31.7 98.31",
    style: {
      fill: "#227EA1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.33,168.09l-.07,0h0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 275.94,
    y: 347.14,
    width: 15.83,
    height: 32.05,
    transform: "translate(9.34 -7.11) rotate(1.46)",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.38,218.7s-1.11,54.52-.73,76.12c.29,16.27,2.83,65,2.83,65s10.26,6.7,21.07,1.1c0,0,6.24-49.22,4.72-64.05a25.09,25.09,0,0,1,0-5.41l9.54-82.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,374.55s8.77-1,10.54-3.86v-1.86s1.52.81,1.23,3.89c-.26,2.86.88,7.73,1.05,13.67a3.1,3.1,0,0,1-1.2,2.52c-1.7,1.31-5.29,3.32-11.62,3.59-2.22.1-11.1,5.79-18.49,5.79s-12.22-3.66-12.22-8.78,15.07-9.75,15.07-9.75l7.24-7s-1.41-7.63,3.2-5.8S281,370.69,281,374.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4,379a.46.46,0,0,1-.44-.32c-1.54-4.61-6.35-5.46-6.4-5.47a.46.46,0,0,1-.38-.53.47.47,0,0,1,.53-.38,9.51,9.51,0,0,1,7.12,6.09.46.46,0,0,1-.29.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,381.86a.48.48,0,0,1-.44-.32c-1.53-4.59-6.35-5.46-6.4-5.47a.45.45,0,0,1-.37-.53.46.46,0,0,1,.53-.38,9.51,9.51,0,0,1,7.12,6.09.46.46,0,0,1-.3.58A.32.32,0,0,1,276.51,381.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,384.34a.45.45,0,0,1-.43-.31c-1.53-4.6-6.35-5.47-6.4-5.48a.46.46,0,1,1,.15-.9,9.48,9.48,0,0,1,7.12,6.09.46.46,0,0,1-.29.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,389.51c0,5.06,4.73,8.69,12,8.77l10.35-4.15c0-10.73-7.26-14.37-7.26-14.37S250.33,384.4,250.33,389.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,386.83c-1.77,1.37-5.53,3.48-12.15,3.77-2.33.1-11.61,6-19.34,6-5.3,0-9.34-1.8-11.36-4.67,1.31,3.79,5.67,6.31,11.8,6.31,7.39,0,16.27-5.69,18.49-5.79,6.33-.27,9.92-2.28,11.62-3.59a3.07,3.07,0,0,0,1.18-2.3A2.5,2.5,0,0,1,293.6,386.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,226.33s1.45,12.34,10.91,18.86l8.35,41.87,5.36-52.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.35,
    y: 356.7,
    width: 15.83,
    height: 32.05,
    transform: "translate(-28.06 26.72) rotate(-4.47)",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,220s1.91,7.23,2.83,37.06c.74,23.64,1.29,37.24,1.49,41.86a26.44,26.44,0,0,0,.37,3.43,337.21,337.21,0,0,1,3.9,36c1.35,23,1.46,33.89,1.46,33.89s-9.76,7.63-21.54,1.64l-11.4-68.54-12-63.61s-16.45-6.27-17.9-23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.83,380.76l.25,3.12s-1.88,2.64-4.1,3.41c0,0-1.7-6.21-4.71-6.53s-9.26-.6-8.42,2.86a28.68,28.68,0,0,1,.87,5.51l-5.8,10.81s-11.77,10.14-6.85,16.6,21.43,3,23.06-7.14a11.26,11.26,0,0,1,4.94-7.53,6.26,6.26,0,0,0,2.81-6.47c-.3-2.32-1-6.78-.79-8.79S338.86,380.79,336.83,380.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,416.54c4.09,5.37,16.15,3.9,21.07-2.56a15.61,15.61,0,0,0,.32-3.19c0-11.55-14.54-10.85-14.54-10.85S303.15,410.08,308.07,416.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,395.4c0-.17-.05-.37-.08-.57a6.18,6.18,0,0,1-2.91,4.52,11.64,11.64,0,0,0-5.1,7.79c-1.66,10.38-18.36,14-23.66,7.59a5.8,5.8,0,0,0,.94,1.81c4.92,6.47,21.43,3,23.06-7.14a11.26,11.26,0,0,1,4.94-7.53A6.26,6.26,0,0,0,338.88,395.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.27,391.54a.47.47,0,0,1-.32-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46,0,1,1-.29-.87,9.47,9.47,0,0,1,9.15,2,.45.45,0,0,1,0,.65A.47.47,0,0,1,329.27,391.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.25,395.55a.47.47,0,0,1-.31-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46,0,0,1-.29-.88,9.52,9.52,0,0,1,9.15,2,.47.47,0,0,1,0,.65A.48.48,0,0,1,327.25,395.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.24,399.56a.47.47,0,0,1-.31-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46,0,0,1-.29-.88,9.49,9.49,0,0,1,9.15,2,.47.47,0,0,1,0,.65A.49.49,0,0,1,325.24,399.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,90.6a89,89,0,0,1-2-12.26c-.24-4.83-1.64-6.52-4.59-4.1s-9.67,9.44-9.27,14.91a34.32,34.32,0,0,0,5.59,17l8.6,2.6,3.44-7.06Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.34,134.32l-17.23-3.81s-7.34-11.89-11.59-18.16-6.66-10.61-6.66-10.61l-8-2.43-4.08,6.89s13.41,33.33,19.63,39c3.13,2.82,23.35,9.08,23.35,9.08S265.25,145.32,261.34,134.32Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,139l-21.72-4.68a56.72,56.72,0,0,1-4.54,19.92L278.62,161Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,139l-21.72-4.68a56.72,56.72,0,0,1-4.54,19.92L278.62,161Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,141.61l10.1,3.18,5.54,29.88-3.28,14.49a16.52,16.52,0,0,0-.25,6L328.83,220s-10,6.38-28.39,6.38-29.06-7.63-29.06-7.63l1.39-56.38A36.66,36.66,0,0,1,283.06,139h0l12.53,1.45Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,94.18s-9.65,8.47-1.26,27.35L289.9,96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 141.61 301.03 145.52 295.59 140.45 295.59 117.66 313.19 117.66 313.19 141.61",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,139c5.94,0,15-5.29,15-9l2-12.37H295.59Z",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27,89c-5.92,0-18.51,3.3-20,18.79s.82,28.68,7.95,28.68c14,0,27.46-1.78,27.57-24.7C315.91,91.5,306.05,89,300.27,89Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,125.3l-2.28-7a1.18,1.18,0,0,1-1.94-.89V104.91s-5.82-1.65-5.2-6.55c0,0-3,2.67-14.41,2.67S275.16,91.34,276.3,86c0,0,2.12,2.19,8.16,2.19s31.19-7.59,31.84,7.6c0,0,2.12-3.11,5.55,0l-4.41,2.62s5.23-.16,4.41,7.51c-.53,5-2.38,13.89-3.58,19.34a12.1,12.1,0,0,1-5.08,7.45h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.61 112.4 291.61 122.35 285.78 120.56 291.61 112.4",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,114a1.86,1.86,0,1,1-1.86-1.87A1.86,1.86,0,0,1,300.87,114Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94,112.68a1.86,1.86,0,1,1-1.86-1.86A1.86,1.86,0,0,1,286.94,112.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,108.8l3.64-2.16s-1.4-1.45-2.79-.58S282.81,108.8,282.81,108.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,110.15,299.15,108s1.4-1.45,2.79-.58S302.8,110.15,302.8,110.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08,127.13s2.7-1.73,5.3-3.68c0,0,1.51,2.94-.87,4.46S292.08,127.13,292.08,127.13Z",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.75 118.4 317.19 111.42 312.56 108.64 310.75 118.4",
    style: {
      fill: "#253239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,115.68c-2.11,3.66-1.56,8.1,1.38,9.62,1.89,1,7.47-1.13,9.58-4.79s.93-6.79-1.94-8.44S313.92,112,311.81,115.68Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,140.45l-2.4,3.81a6.17,6.17,0,0,0,2.51,8.84h0a11.3,11.3,0,0,0,15.53-6.21l2-5.28-8.8-3.15Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86,101.74s2.94-4.48,2.89-8.73.48-6.22,1.21-7.24-.09-2.51-2.05-2c-1.66.45-3.71,3-4.16,5.35a2.56,2.56,0,0,1-1.27,1.79c-2.07,1.11-5.93,4.29-4.1,12Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,97.66h0a.35.35,0,0,1-.29-.4,8.93,8.93,0,0,1,4.61-6.64,2.14,2.14,0,0,0,1.1-1.54.35.35,0,0,1,.41-.27.34.34,0,0,1,.27.4,2.85,2.85,0,0,1-1.45,2,8.24,8.24,0,0,0-4.26,6.14A.34.34,0,0,1,218,97.66Z",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.77 181.63 329.21 190.99 352 200.01 342.81 172.16 324.77 181.63",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,144.37s-7.6,7.81-4.31,18.82a116.1,116.1,0,0,0,7.14,18.44s12.81.38,18-9.47l-6.53-16.48a17.88,17.88,0,0,0-12-10.67Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,144.37s-7.6,7.81-4.31,18.82a116.1,116.1,0,0,0,7.14,18.44s12.81.38,18-9.47l-6.53-16.48a17.88,17.88,0,0,0-12-10.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.93,189.25c5.76,1.69,22.74,6.72,22.74,6.72s.13.37,1.33,4c1.84,5.65-4,19.32-24.68,9.4s-28.23-15.23-28.23-15.23l2.25-12.55S321.36,187.32,327.93,189.25Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.54 189.54 339.25 192.63 327.26 186.84 328.54 189.54",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,199.81l-13.44-1.43a2.38,2.38,0,0,1-2.06-1.76L275.3,169a1.24,1.24,0,0,1,1.26-1.56l13,.61a2.27,2.27,0,0,1,2.1,1.68l7.82,28.53A1.25,1.25,0,0,1,298.14,199.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,171.49a1.16,1.16,0,1,1-1.15-1.16A1.16,1.16,0,0,1,280.55,171.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.34,181.63s-3.89-6.76-8.72-8.4l1.93,7.43s-3.67.29-7.82.29-8.69-2.8-10-3.52-2.53,4.3,2.69,13.76,19.71,3,19.71,3Z",
    style: {
      fill: "#945959"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.06,45.63l7.24,4.12V47.19c0-.18,0-.37,0-.54s0-.35,0-.52v-.06h0c.26-3.4,2.83-4.7,6-2.89a11.72,11.72,0,0,1,3.57,3.43c.71-4.61,4.47-6.28,9-3.65C390.91,45.87,395,53,395,58.8v5.49a2.52,2.52,0,0,0,1.24,2.15l4.25,2.49a6.15,6.15,0,0,1,3,5.3,2.54,2.54,0,0,1-3.8,2.19L360.17,53.56a6.91,6.91,0,0,1-3.45-6A2.24,2.24,0,0,1,360.06,45.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,91.68l5.35,3V92.83c0-.14,0-.27,0-.4s0-.26,0-.39v0h0c.19-2.51,2.09-3.47,4.41-2.13a8.55,8.55,0,0,1,2.64,2.53c.52-3.41,3.3-4.64,6.67-2.7a15,15,0,0,1,6.76,11.72v4.06a1.85,1.85,0,0,0,.91,1.59l3.15,1.84a4.55,4.55,0,0,1,2.24,3.92,1.87,1.87,0,0,1-2.8,1.62L391.52,97.54A5.1,5.1,0,0,1,389,93.12,1.65,1.65,0,0,1,391.44,91.68Z",
    style: {
      fill: "#e6e6e6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentMesage);
export default __webpack_public_path__ + "static/media/sent-mesage.31ef87523725928ae8a971b6d869e8f0.svg";
export { ForwardRef as ReactComponent };